module.exports = __webpack_public_path__ + "static/img/vipps.d68826e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment_methods/vipps.png
// module id = ZMbT
// module chunks = 1